const navigations = {
    items: [
        {
            name: "Dashboard",
            url: "/dashboard",
            icon: "fa fa-dashboard",
        },
        {
            name: "User",
            url: "/user",
            icon: "fa fa-user",
        },
        {
            name: "Category",
            url: "/category",
            icon: "fa fa-list",
        },
        {
            name: "Analytics",
            url: "/analytics",
            icon: "fa fa-bar-chart",
        }
    ]
};

export default navigations;